import { baseElementSchema } from "@/Components/Exercises/Elements/base";
import { stringReturnOpSchema } from "@/Components/Exercises/LogicOperation";
import { z } from "zod";

export const likertListElementSchema = baseElementSchema.extend({
    type: z.literal("likertList"),
    title: z.union([z.string(), stringReturnOpSchema]),
    questions: z.array(
        z.array(
            z.string().describe("Category"),
            z.string().describe("Question"),
        ),
    ),
});

const likertListAnswerSchema = z.union([
    z.literal("Strongly disagree"),
    z.literal("Disagree"),
    z.literal("Neutral"),
    z.literal("Agree"),
    z.literal("Strongly agree"),
]);

export const likertListElementDataSchema = z.object({
    answers: z
        .record(
            z.string().describe("Question"),
            likertListAnswerSchema.optional().describe("Answer"),
        )
        .optional(),
    topCategories: z.array(z.string()).optional(),
});

export type LikertListElement = z.infer<typeof likertListElementSchema>;
export type LikertListElementData = z.infer<typeof likertListElementDataSchema>;

export type LikertListElementAnswer = z.infer<typeof likertListAnswerSchema>;
